document.addEventListener("DOMContentLoaded", () => {

  const cards = document.querySelectorAll(".sounfree-card");

  if (!cards.length) return;

  let activeAudio = null;
  let activeCard = null;
  let hoverTimeout = null;

  const isTouchDevice =
    window.matchMedia("(hover: none)").matches;

  /* =========================
   AUDIO UNLOCK
========================= */

function unlockAudio() {

  const audio = new Audio();

  audio.volume = 0;

  audio.play().catch(() => {});

  window.removeEventListener("mousemove", unlockAudio);
  window.removeEventListener("touchstart", unlockAudio);
  window.removeEventListener("scroll", unlockAudio);

}

window.addEventListener("mousemove", unlockAudio, {
  once: true
});

window.addEventListener("touchstart", unlockAudio, {
  once: true
});

window.addEventListener("scroll", unlockAudio, {
  once: true
});
  
    /* =========================
     AUDIO SYSTEM
  ========================= */

  function stopAudio() {

    if (activeAudio) {

      activeAudio.pause();
      activeAudio.currentTime = 0;

      activeAudio = null;

    }

  }

  function deactivateCard(card) {

    if (!card) return;

    card.classList.remove("is-previewing");

  }

  function deactivateAllCards() {

    cards.forEach((card) => {
      card.classList.remove("is-previewing");
    });

  }

  function playPreview(card) {

    const audioSrc =
      card.dataset.previewAudio;

    if (!audioSrc) return;

    if (activeCard === card) return;

    stopAudio();

    deactivateAllCards();

    const audio = new Audio(audioSrc);

    audio.volume = 0;

    audio.play().catch(() => {});

    let volume = 0;

    const fadeIn = setInterval(() => {

      volume += 0.08;

      if (volume >= 1) {

        volume = 1;

        clearInterval(fadeIn);

      }

      audio.volume = volume;

    }, 40);

    activeAudio = audio;
    activeCard = card;

    card.classList.add("is-previewing");

  }

  function stopPreview() {

  stopAudio();

  deactivateAllCards();

  activeCard = null;

}

  /* =========================
     DESKTOP
  ========================= */

  if (!isTouchDevice) {

    cards.forEach((card) => {

      card.addEventListener("mouseenter", () => {

        clearTimeout(hoverTimeout);

        hoverTimeout = setTimeout(() => {

          playPreview(card);

        }, 180);

      });

      card.addEventListener("mouseleave", () => {

        clearTimeout(hoverTimeout);

        stopPreview();

      });

    });

  }

  /* =========================
     MOBILE / TABLET
  ========================= */

  if (isTouchDevice) {

    cards.forEach((card) => {

      card.addEventListener("click", (e) => {

        const button =
          e.target.closest(".sounfree-card__button");

        if (button) return;

        if (!card.classList.contains("is-previewing")) {

          e.preventDefault();

          deactivateAllCards();

          playPreview(card);

        }

      });

    });

    document.addEventListener("click", (e) => {

      const insideCard =
        e.target.closest(".sounfree-card");

      if (!insideCard) {

        stopPreview();

      }

    });

  }

});